import IconBase, { type IconProps } from '@yoweb/ui/components/Icon/IconBase';

export function CloseIconSmall(props: IconProps) {
  return (
    <IconBase {...props}>
      <path
        d="M8 8L16 16"
        stroke="#323232"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 8L8 16"
        stroke="#323232"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </IconBase>
  );
}

export default CloseIconSmall;
